"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Loading = ({ state }) => {
    const message = [
        "연결중입니다.",
        "채팅 서버 상태를 확인해주세요."
    ];
    return (react_1.default.createElement("div", { style: {
            display: "flex",
            flexFlow: "column",
            justifyContent: "center",
            position: "absolute",
            width: "100%",
            height: "100%",
            background: "rgb(60, 60, 60, 50%)",
        } },
        react_1.default.createElement("h2", { style: {
                textAlign: "center",
                fontSize: "0.9rem",
                fontWeight: "normal",
                color: "tomato",
                textShadow: "0.5px 0.5px #88473b",
            } }, message[state])));
};
exports.default = Loading;
